import ApiCore from "./api_core"
import { NewLabOrder } from "./types";

export default new class {
    createOrder(order: NewLabOrder) { return ApiCore.postJson('lab/orders', order) }

    getTestTypes() { return ApiCore.getJson('lab/test_types') }

    getTestTypesBySpecimen(specimenType='') {
        return ApiCore.getJson('lab/test_types', { specimen_type: specimenType });
    }

    getSpecimens(testName: string) {
        return ApiCore.getJson('lab/specimen_types', { 'test_type': testName });
    }

    verifyAccessionNumber(accessionNumber: string) {
        return ApiCore.getJson('lab/accession_number', { accession_number: accessionNumber })
    }
}